var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHuntsTitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FF824D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0003 10.5V13.0334C30.0003 13.7053 29.7334 14.3496 29.2583 14.8247C28.7832 15.2998 28.1388 15.5667 27.4669 15.5667H13.5334C12.8615 15.5667 12.2171 15.2998 11.742 14.8247C11.2669 14.3496 11 13.7053 11 13.0334V10.5",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2005 21.2667C26.2005 24.4335 23.6481 29.5002 20.5004 29.5002C17.3527 29.5002 14.8003 24.4335 14.8003 21.2667C14.8003 19.755 15.4008 18.3051 16.4698 17.2362C17.5388 16.1672 18.9886 15.5667 20.5004 15.5667C22.0121 15.5667 23.462 16.1672 24.531 17.2362C25.5999 18.3051 26.2005 19.755 26.2005 21.2667Z",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4996 26.9671C21.549 26.9671 22.3997 26.1164 22.3997 25.067C22.3997 24.0177 21.549 23.167 20.4996 23.167C19.4503 23.167 18.5996 24.0177 18.5996 25.067C18.5996 26.1164 19.4503 26.9671 20.4996 26.9671Z",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8003 13.0332V15.5666",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2002 13.0332V15.5666",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2437 18.0999H30.0001C30.0001 19.1077 29.5997 20.0743 28.887 20.7869C28.1744 21.4996 27.2078 21.8999 26.2 21.8999",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7564 18.0999H11C11 19.1077 11.4004 20.0743 12.113 20.7869C12.8257 21.4996 13.7922 21.8999 14.8001 21.8999",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuntsTitle);
export default __webpack_public_path__ + "static/media/huntsTitle.b6bf4cffa36908ee456730fa913f9270.svg";
export { ForwardRef as ReactComponent };